import React from "react"
import { T } from "../../traks"
import { Card, Col, Container, Row } from "reactstrap"

export const PremiumGuide = () => {
    return (
        <Card className="border-radius-10 mt-4 pt-3 pb-3 no-border-color">
            <Container>
            <Row className='mt-2'>
                <Col sm="5">
                <Row>
                    <Col>
                        <h2 className="txt-40px fw_900"><T>Upgrading is this easy</T></h2>
                    </Col> 
                </Row>
                <Row>
                    <img src='https://static.aktiedysten.dk/imgs/premium-image-0.png' style={{width: "100%"}} alt='premium'/>
                </Row>
                    
                </Col>
                <Col>
                    <Row>
                        <b>1.&nbsp;</b> <b><T>Choose a number of participants or package</T></b>
                    </Row>
                    <Row>
                        <T>You decide how many participants you want to invite to your Premium games.</T>
                    </Row>
                    <Row className='mt-3'>
                        <b>2.&nbsp;</b> <b><T>Choose duration</T></b>
                    </Row>
                    <Row>
                        <T>Select how long you want it to last.</T>
                    </Row>
                    <Row className='mt-3'>
                        <b>3.&nbsp;</b> <b><T>Create your games - again and again</T></b>
                    </Row>
                    <Row>
                        <T>You can create as many games as you like - with full access to all Premium features.</T>
                    </Row>
                    <Row className='mt-3'>
                        <b>4.&nbsp;</b> <b><T>Invitations are not personal</T></b>
                    </Row>
                    <Row>
                        <T>When a game expires, the invitations are automatically released and can be used for new games - as long as your Premium period is still active.</T>
                    </Row>
                </Col>
            </Row>
            </Container>
            
            </Card>
    )
}


// WEBPACK FOOTER //
// ./src/c/Premium/PremiumGuide.js